// extracted by mini-css-extract-plugin
export default {"product_sidebar_container":"ProdSide_product_sidebar_container__YPVbP"};